import styled from 'styled-components';

import Link from '../../../Core/Link';
import { Cards } from '../../Shared/PricingSection/styles';

export const TutoringCards = styled(Cards).attrs(({ columns }) => ({
  columns,
}))`
  background: url(${(props) => props.mobileBackground}) no-repeat top center;
  padding-top: 200px;

  @media only screen and (min-width: 1400px) {
    background: url(${(props) => props.background}) no-repeat bottom left;
    padding: 0;
    justify-content: flex-end;
  }
`;

export const TutoringCTAContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const TutoringCTALink = styled(Link)`
  align-self: center;
  margin-bottom: 100px;
`;
